import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from 'src/app/core/backend-services/http/http.backend-service';
import {
  RetentionStatusResponse,
  ClaimDailyResponse,
  ClaimWeeklyResponse,
} from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class RetentionBackendService {
  private readonly BASE_ADDRESS = '/retention';

  /**
   * @description constructor of RetentionBackendService
   * @param {HttpBackendService} http - http backend service
   */
  constructor(private http: HttpBackendService) {}

  /**
   * @description gets retention status including streak, daily challenges, and weekly goal
   * @returns {Promise<RetentionStatusResponse>}
   */
  public getStatus(): Promise<RetentionStatusResponse> {
    return firstValueFrom(
      this.http.get<RetentionStatusResponse>(`${this.BASE_ADDRESS}/status`)
    );
  }

  /**
   * @description claims daily streak reward
   * @returns {Promise<ClaimDailyResponse>}
   */
  public claimDaily(): Promise<ClaimDailyResponse> {
    return firstValueFrom(
      this.http.post<ClaimDailyResponse>(`${this.BASE_ADDRESS}/claim-daily`, {})
    );
  }

  /**
   * @description claims weekly goal reward
   * @returns {Promise<ClaimWeeklyResponse>}
   */
  public claimWeekly(): Promise<ClaimWeeklyResponse> {
    return firstValueFrom(
      this.http.post<ClaimWeeklyResponse>(`${this.BASE_ADDRESS}/claim-weekly`, {})
    );
  }

  /**
   * @description tracks a game event for challenge progress
   * @param {string} event - event type (e.g., 'game_won', 'called_40')
   * @returns {Promise<any>}
   */
  public trackEvent(event: string): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(`${this.BASE_ADDRESS}/track-event`, { event })
    );
  }
}
